// context/BUContext.js
import React, { createContext, useState } from 'react';

export const BUContext = createContext();

export const BUProvider = ({ children }) => {
  const [selectedBU, setSelectedBU] = useState('ALL');

  return (
    <BUContext.Provider value={{ selectedBU, setSelectedBU }}>
      {children}
    </BUContext.Provider>
  );
};
